/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.PAYTYPES_RECEIVE]: (state, action) => {
            return reduce(
                action.payload.paytypes,
                (memo, paytype) => {
                    const { code } = paytype;
                    if (memo === state) {
                        memo = { ...memo };
                    }
                    memo[code] = paytype;
                    return memo;
                },
                state,
            );
        }
    },
);